import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Select, Input, Button, Divider } from "antd";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import { openNotificationType } from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import RegistrationDataProvider from "../../Screens/Registration/RegistrationFormView/RegistrationDataProvider";
import { NOTIFICATIONS } from "../../constants";
import { ErrorLogger } from "../../../App/Utils/ErrorHandler";

class AntDSelectWrapper extends Component {
  DataProvider = new RegistrationDataProvider();

  state = {
    [this.props.decorator]: [],
    selfLoad: false,
    otherTypeText: "",
    isDuplicate: false,
  };

  componentDidMount() {
    try {
      if (this.props.options.length === 0) {
        if (this.props.app !== undefined && this.props.entity !== undefined) {
          this.getDropdownData();
        }
      } else if (this.props.options.length === 1) {
        this.props.formRef.current.setFieldsValue({
          [this.props.decorator]: this.props.options[0][
            this.props.primary_key_field
          ],
        });
      }
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
    }
  }

  getDropdownData = () => {
    try {
      this.DataProvider.get_dropdown_data_api(
        this.props.app,
        this.props.entity
      ).then((res) => {
        if (res.ok) {
          return res.json().then((res) =>
            this.setState(
              { [this.props.decorator]: res, selfLoad: true },
              () => {
                if (res.length === 1) {
                  this.props.formRef.current.setFieldsValue({
                    [this.props.decorator]:
                      res[0][this.props.primary_key_field],
                  });
                }
              }
            )
          );
        } else {
          openNotification(
            openNotificationType.error,
            NOTIFICATIONS.ERROR_OCCURED,
            NOTIFICATIONS.REFRESH_PAGE
          );
        }
      });
    } catch (error) {
      ErrorLogger(error.toString());
      console.error(error);
      openNotification(
        openNotificationType.error,
        NOTIFICATIONS.ERROR_OCCURED,
        NOTIFICATIONS.REFRESH_PAGE
      );
    }
  };

  onChange = (e) => {
    try {
      if (this.props.onChange !== undefined) {
        if (this.props.options.length === 0) {
          this.props.onChange(
            this.props.decorator,
            this.state[this.props.decorator].filter(
              (record) => record[this.props.primary_key_field] === e
            )[0]
          );
        } else {
          this.props.onChange(
            this.props.decorator,
            this.props.options.filter(
              (record) => record[this.props.primary_key_field] === e
            )[0]
          );
        }
      }
    } catch (error) {}
  };

  handleOther = (e) => {
    try {
      this.setState({ otherTypeText: e.target.value, isDuplicate: false });
    } catch (error) {}
  };

  addOther = () => {
    try {
      // CHECK IF CUSTOM VALUE ALREADY EXISTS
      const current_data =
        this.props.options === undefined
          ? this.state.options
          : this.props.options;
      let query=null
      if(this.state.otherTypeText)
      {
       query = current_data.filter(
        (c) => c.name.toLowerCase() === this.state.otherTypeText.toLowerCase()
      );
       }
      if (query.length > 0) {
        this.setState({ isDuplicate: true });
      } else {
        // ELSE ADD CUSTOM VALUE
        let options = [];
        if (this.props.options.length === 0) {
          options = this.state[this.props.decorator];
          options.unshift({
            [this.props.primary_key_field]: `${this.state.otherTypeText}${
              options.length + 1
            }`,
            name: this.state.otherTypeText,
            other: true,
          });
        } else {
          options = this.props.options;
          options.unshift({
            [this.props.primary_key_field]: `${this.state.otherTypeText}${
              options.length + 1
            }`,
            name: this.state.otherTypeText,
            other: true,
          });
        }

        this.setState(
          {
            [this.props.decorator]: options,
            selfLoad: true,
            otherTypeText: "",
          },
          () => {
            this.props.formRef.current.setFieldsValue({
              [this.props.decorator]: options[0][this.props.primary_key_field],
            });
            this.onChange(options[0][this.props.primary_key_field]);
          }
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  handleSearch = (q) => {
    try {
      if (this.props.handleSearch !== undefined) {
        this.props.handleSearch(this.props.decorator, q);
      }
    } catch (error) {}
  };

  onClear = () => {
    try {
      if (this.props.onClear !== undefined) {
        this.props.onClear(this.props.decorator);
      }
    } catch (error) {}
  };

  /**
   * To resolve issue where combobox does not display updated
   * options if other type is added
   */
  isSelfLoad = () => {
    try {
      if (
        this.props.options.length > 0 &&
        this.state[this.props.decorator].length > 0
      ) {
        const name = this.props.options[0].name;
        if (
          this.state[this.props.decorator].filter((each) => each.name === name)
            .length > 0
        ) {
          return true;
        } else {
          return false;
        }
      }
      return this.state.selfLoad;
    } catch (error) {}
  };

  render() {
    return (
      <Form.Item
        id={this.props.id}
        name={this.props.decorator}
        label={this.props.label}
        rules={[
          {
            required: this.props.required,
            message: this.props.message,
          },
          ...this.props.validators,
        ]}
      >
        <Select
          showSearch
          mode={this.props.multiple}
          allowClear={this.props.allowClear}
          onClear={this.onClear}
          autoComplete="none"
          optionFilterProp="children"
          disabled={this.props.disabled}
          placeholder={this.props.placeholder}
          onSearch={this.handleSearch}
          onChange={this.onChange}
          dropdownRender={(menu) => (
            <>
              {menu}

              {this.props.othertype && (
                <>
                  <Divider className="divider-margin" />
                  <div className="other-option-div">
                    <Input
                      className="other-input"
                      placeholder="Type other"
                      value={this.state.otherTypeText}
                      onChange={this.handleOther}
                    />

                    <Button
                      id="add-other"
                      type="primary"
                      onClick={this.addOther}
                    >
                      Add
                    </Button>
                  </div>
                  {this.state.isDuplicate && (
                    <p className="error-text">{`${this.state.otherTypeText} Already Available.`}</p>
                  )}
                </>
              )}
            </>
          )}
        >
          {this.isSelfLoad()
            ? this.state[this.props.decorator].map((item) => (
                <Select.Option value={item[this.props.primary_key_field]}>
                  {this.props.prefixId
                    ? item["code"] + " - " + item["name"]
                    : item["name"]}
                </Select.Option>
              ))
            : this.props.options.map((item) => (
                <Select.Option value={item[this.props.primary_key_field]}>
                  {this.props.prefixId
                    ? item["code"] + " - " + item["name"]
                    : item["name"]}
                </Select.Option>
              ))}
        </Select>
      </Form.Item>
    );
  }
}

AntDSelectWrapper.propTypes = {
  options: PropTypes.array,
};

export default AntDSelectWrapper;
